import { useCreateSlide } from '../../api-http/slides-v2';
import { AlertBar } from '../../components/AlertBar';
import devices from '../../components/canvas-editor-v2/assets/devices.json';
import { formMsg } from '../../configs';
import { getDefaultProjectDataV2 } from '../../util/getDefaultProjectData';
import LoadingButton from '@mui/lab/LoadingButton';
import { Stack, MenuItem, TextField } from '@mui/material';
import { useFormik } from 'formik';
import React, { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import * as yup from 'yup';

interface SlideFormProps {
  onFinished: () => void;
}

const validationSchema = yup.object({
  title: yup.string().required(formMsg.TITLE_REQUIRED),
});

export const SlideForm: FC<SlideFormProps> = ({ onFinished }) => {
  const navigate = useNavigate();
  const { isLoading, mutate, error, data } = useCreateSlide();

  useEffect(() => {
    if (data?._id) {
      onFinished();
      navigate(`/editor-v2/${data?._id}`);
    }
  }, [data]);

  const formik = useFormik({
    initialValues: {
      title: '',
      deviceType: devices[0].id,
      status: true,
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      const deviceInfo =
        devices.find((d) => d.id == values.deviceType) || devices[0];
      const projectData = {
        name: values.title,
        used: 1,
        projectData: getDefaultProjectDataV2(deviceInfo),
      };
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { deviceType: _deviceType, ...rest } = values;
      mutate({
        ...rest,
        projectData: projectData?.projectData,
        dynamicData: [],
      });
    },
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <Stack spacing={2} sx={{ pt: 2 }}>
        <AlertBar severity="error" msg={error?.msg} mb={2} />
        <TextField
          size="small"
          fullWidth
          id="title"
          name="title"
          label="Slide title"
          value={formik.values.title}
          onChange={formik.handleChange}
          error={formik.touched.title && Boolean(formik.errors.title)}
          helperText={formik.touched.title && formik.errors.title}
        />
        <TextField
          select
          size="small"
          fullWidth
          id="deviceType"
          name="deviceType"
          value={formik.values.deviceType}
          label="Screen size"
          onChange={formik.handleChange}
        >
          {devices.map((device) => (
            <MenuItem key={device.id} value={device.id}>
              {device.name} ({device.type})
            </MenuItem>
          ))}
        </TextField>

        <LoadingButton
          color="primary"
          disabled={!formik.values.title}
          variant="contained"
          fullWidth
          type="submit"
          loading={isLoading}
          sx={{ height: 40 }}
        >
          Create
        </LoadingButton>
      </Stack>
    </form>
  );
};
